import { analyticsUrl } from 'utils/wrappers';

import PageableBase, { PAGING_TYPES } from 'app/collections/pageable_base';
import Tracker from 'app/models/tracker';

export default PageableBase.extend({
  model: Tracker,
  key: 'trackers',
  url: analyticsUrl('tracking/v2/trackers/delaying'),
  pagingType: PAGING_TYPES.PER_PAGE,
});



// WEBPACK FOOTER //
// ./app/collections/delayed_trackers.js